import { create } from 'zustand';
import type { CoinSummary, Trade } from '@/api/types';

export interface CoinMeta {
  symbol: string;
  name: string;
  image: string;
}

interface TickerState {
  trades: Trade[];
  meta: Record<string, CoinMeta>;
  pushTrade: (t: Trade) => void;
  seed: (t: Trade[]) => void;
  learn: (coins: Pick<CoinSummary, 'mint' | 'symbol' | 'name' | 'image'>[]) => void;
}

const MAX = 40;
const key = (t: Trade) => `${t.sig}:${t.ix}`;

export const useTicker = create<TickerState>()((set) => ({
  trades: [],
  meta: {},
  pushTrade: (t) =>
    set((s) => {
      if (s.trades.some((x) => key(x) === key(t))) return s;
      return { trades: [t, ...s.trades].slice(0, MAX) };
    }),
  seed: (ts) =>
    set((s) => {
      const seen = new Set(s.trades.map(key));
      const merged = [...s.trades, ...ts.filter((t) => !seen.has(key(t)))].sort((a, b) => b.ts - a.ts || b.slot - a.slot);
      return { trades: merged.slice(0, MAX) };
    }),
  learn: (coins) =>
    set((s) => {
      let changed = false;
      const meta = { ...s.meta };
      for (const c of coins) {
        const m = meta[c.mint];
        if (!m || m.symbol !== c.symbol || m.image !== c.image) {
          meta[c.mint] = { symbol: c.symbol, name: c.name, image: c.image };
          changed = true;
        }
      }
      return changed ? { meta } : s;
    }),
}));
